"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GENERAL_TRANSACTION = exports.TRADE = exports.WITHDRAW = exports.DEPOSIT = exports.SIMPLE_MOVEMENT = exports.DISBURSE = exports.HOLD = void 0;
exports.HOLD = 'HOLD';
exports.DISBURSE = 'DISBURSE';
exports.SIMPLE_MOVEMENT = 'SIMPLE_MOVEMENT';
exports.DEPOSIT = 'DEPOSIT';
exports.WITHDRAW = 'WITHDRAW';
exports.TRADE = 'TRADE';
exports.GENERAL_TRANSACTION = 'GENERAL_TRANSACTION';
